import React from 'react';
import {create} from 'jss';
import rtl from 'jss-rtl';
import {jssPreset, StylesProvider} from '@material-ui/core/styles';
// Configure JSS
const jss: any = create({plugins: [...jssPreset().plugins, rtl()]});

const CremaStyleProvider: any = (props: any) => {
  return <StylesProvider jss={jss}>{props.children}</StylesProvider>;
};
export default CremaStyleProvider;
